module.exports = __webpack_public_path__ + "media/ibisz_m.a331702d.mp3";